import useTranslation from 'next-translate/useTranslation';
import { ChevronRightIcon } from 'src/themes/cosmos/icons';
import SettingOption from 'src/themes/cosmos/components/SettingOption';
import { NAVIGATION_KEYS, SETTING_CONTAINERS } from 'src/interfaces/enums';
import useKeyboardInteractions from 'src/hooks/useKeyboardInteractions';
import { useMemo } from 'react';
import styles from './styles.module.scss';

export interface IMainSettingControlProps {
  onChange: (container: SETTING_CONTAINERS) => void;
  resolution: { value: string; visible: boolean };
  speed: { value: string; visible: boolean };
}

const MainSettingControl = ({ onChange, resolution, speed }: IMainSettingControlProps) => {
  const { t } = useTranslation('common');
  const { registerItem } = useKeyboardInteractions();

  const visibleSettings = useMemo(() => {
    const settings = [
      { ...resolution, setting_container: SETTING_CONTAINERS.RESOLUTION, title: t('settings.quality') },
      { ...speed, setting_container: SETTING_CONTAINERS.PLAYBACK_RATE, title: t('settings.speed') },
    ];

    return settings.filter((settings) => settings.visible);
  }, [resolution, speed, t]);

  function handleChange(index: number) {
    onChange(visibleSettings[index].setting_container);
  }

  return (
    <>
      {visibleSettings.map((setting, index) => {
        return (
          <SettingOption
            {...registerItem({
              index,
              keyActions: {
                [NAVIGATION_KEYS.ARROW_RIGHT]: () => handleChange(index),
              },
            })}
            aria-haspopup
            key={setting.title}
            className={styles.settingOption}
            data-testid={`${setting.setting_container}-settings`}
            rightIcon={<ChevronRightIcon />}
            onClick={() => handleChange(index)}
          >
            <div className={styles.content}>
              <strong>{setting.title}</strong>
              <span>{setting.value}</span>
            </div>
          </SettingOption>
        );
      })}
    </>
  );
};

export default MainSettingControl;
